import { NGX_MAT_NATIVE_DATE_FORMATS, NgxMatDateFormats } from '@angular-material-components/datetime-picker';
import {
  CUSTOM_DATE_INPUT
} from '../../pages/v2/create-service-request/modules/create-service-request-step4/properties/create-service-request-step4.properties';

/**
 * application properties
 */
export const NOTIFICATION_SUCCESS_TIME = 8000;
export const NOTIFICATION_ERROR_TIME = 6000;
export const NOTIFICATION_WARNING_TIME = 6000;
export const NOTIFICATION_INFO_TIME = 8000;

// Pattern for field password : 8+ symbols, small+capital, digits, alpha, special character
export const PASSWORD_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!#$%\^&*+=\-\[\]\\';,./{}|\\":<>\?_@])(?!.*\s).{8,20}$/;

// only numbers pattern
export const ONLY_NUMBERS_PATTERN = '[- +()0-9]+';

export const EMPTY_GUID_VALUE = '00000000-0000-0000-0000-000000000000';
export const NO_DATA = 'N/A';

/**
 * Configuration for ngx mat datetimepicker component, should be provided using `NGX_MAT_DATE_FORMATS` injectionToken
 *
 * **Note:** `@angular-material-components/datetime-picker` uses `Intl.DateTimeFormat` so any configuration should be in
 * `Intl.DateTimeFormatOptions` format
 */
export const CUSTOM_NGX_MAT_NATIVE_DATE_FORMATS: NgxMatDateFormats = {
  display: {
    ...NGX_MAT_NATIVE_DATE_FORMATS.display,
    /**
     * This property configures how we want to see date and time in the input field
     */
    dateInput: CUSTOM_DATE_INPUT,
  },
  parse: {
    ...NGX_MAT_NATIVE_DATE_FORMATS.parse,
  },
};
